import Loader from './Loader';
import Footer from '../Footer';

export { Loader, Footer };
